import React, { createContext, useEffect, useState } from 'react';
import UseAxiosPublic from '../hooks/UseAxiosPublic';


export const AuthContext = createContext(null);

const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [error, setError] = useState(null);
    const axiosPublic = UseAxiosPublic();

    // 1. Check active session on app load (Replaces localStorage + jwtDecode)
  useEffect(() => {
    const checkAuthStatus = async () => {
        try {
            const res = await axiosPublic.get('/me');
            if (res.data.success) {
                setUser(res.data.user);
                setIsAuthenticated(true);
            }
        } catch (err) {
            // 💡 Quietly handle unauthenticated guest visits
            setUser(null);
            setIsAuthenticated(false);
            // Don't set global error state for normal 401 unauthenticated checks!
        } finally {
            setLoading(false);
        }
    };

    checkAuthStatus();
}, []);

    // 2. Login User
    const loginUser = async (email, password) => {
        try {
            const res = await axiosPublic.post('/login', { email, password });

            if (res.data.success) {
                // User object returned directly from response body
                setUser(res.data.user);
                setIsAuthenticated(true);
                return res.data;
            }
        } catch (err) {
            return {
                success: false,
                message: err.response?.data?.message || "Login failed"
            };
        }
    };

    // 3. Logout User
    const logOutUser = async () => {
        try {
            // Tells server to call res.clearCookie("token")
            await axiosPublic.post('/logout'); 
        } catch (err) {
            console.error("Logout error:", err);
        } finally {
            // Always clean up UI state
            setUser(null);
            setIsAuthenticated(false);
        }
    };

    const authInfo = {
        user,
        loading,
        isAuthenticated,
        loginUser,
        logOutUser,
        error
    };

    return (
        <AuthContext.Provider value={authInfo}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;